import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/initial_screens/InitialMainView.vue')
  },
  {
    path: '/productmain',
    name: 'Product main',
    component: () => import('../views/initial_screens/ProductMainView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/you/LoginView.vue')  
  },
  {
    path: '/explorer',
    name: 'Explorer',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/deprecated/ExplorerView.vue')
  },
  {
    path: '/repmanager',
    name: 'RepertoireManager',
    component: () => import('../views/repertoire/RepManagerView.vue')
  },
  {
    path: '/repbuilder',
    name: 'RepertoireBuilder',
    component: () => import('../views/repertoire/RepBuilderView.vue')
  },
  {
    path: '/repimport',
    name: 'RepertoireImport',
    component: () => import('../views/repertoire/RepImportView.vue')
  },
  {
    path: '/repexport',
    name: 'RepertoireExport',
    component: () => import('../views/repertoire/RepExportView.vue')
  },
  {
    path: '/replibrary',
    name: 'RepertoireLibrary',
    component: () => import('../views/repertoire/RepLibraryView.vue')
  },
  {
    path: '/reptree',
    name: 'RepertoireTree',
    component: () => import('../views/repertoire/RepTreeView.vue')
  },
  {
    path: '/playcollection',
    name: 'PlayGameCollection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/opening/PlayCollectionView.vue')
  },
  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/you/RegisterView.vue')
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/you/SubscribeBlurbView.vue')
  },
  {
    path: '/logoff',
    name: 'logoff',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/you/LogoffView.vue')
  },
  {
    path: '/preferences',
    name: 'preferences',
    component: () => import('../views/you/PreferencesView.vue')
  },
  {
    path: '/passwordreset',
    name: 'passwordreset',
    component: () => import('../views/you/PasswordResetView.vue')
  },
  {
    path: '/stripe_success',
    name: 'stripe_success',
    component: () => import('../views/stripe/StripeSuccessView.vue')
  },
  {
    path: '/stripe_cancel',
    name: 'stripe_cancel',
    component: () => import('../views/stripe/StripeCancelView.vue')
  },
  {
    path: '/reppractice',
    name: 'reppractice',
    component: () => import('../views/repertoire/RepPracticeView.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/support/ContactView.vue')
  },
  ,
  {
    path: '/whatsnew',
    name: 'Whatsnew',
    component: () => import('../views/support/WhatsnewView.vue')
  },
  {
    path: '/tos',
    name: 'Terms',
    component: () => import('../views/support/TOSView.vue')
  },
  {
    path: '/verify',
    name: 'Verify Email',
    component: () => import('../views/you/SendEmailVerifyView.vue')
  },
  {
    path: '/emailverified',
    name: 'Email Verified',
    component: () => import('../views/you/EmailVerifiedView.vue')
  },
  {
    path: '/puzzles',
    name: 'Puzzles',
    component: () => import('../views/puzzles/PuzzlesView.vue')
  },
  {
    path: '/masterexplorer',
    name: 'Master Player Explorer',
    component: () => import('../views/opening/MasterSearchView.vue')
  },
  {
    path: '/openingfinder',
    name: 'Opening Finder',
    component: () => import('../views/deprecated/OpeningFinderView.vue')
  },
  {
    path: '/whosguarding',
    name: 'Who is Guarding',
    component: () => import('../views/visualization/WhosGuardingView.vue')
  },
  {
    path: '/staticboard',
    name: 'Static Board',
    component: () => import('../views/visualization/StaticBoardView.vue')
  },
  {
    path: '/movefollowing',
    name: 'Move Following',
    component: () => import('../views/visualization/MoveFollowingView.vue')
  },
  {
    path: '/blindfoldplay',
    name: 'Blindfold Play',
    component: () => import('../views/engines_play/BlindfoldPlayView.vue')
  },
  {
    path: '/blindfoldhistory',
    name: 'Blindfold History',
    component: () => import('../views/engines_play/BlindHistoryView.vue')
  },
  {
    path: '/blindfoldreview',
    name: 'Blindfold Game Review',
    component: () => import('../views/engines_play/BlindReviewView.vue')
  },
  {
    path: '/endgamestudy',
    name: 'End Game Study',
    component: () => import('../views/engines_play/EndGameStudyView.vue')
  },
  {
    path: '/explorerfuture',
    name: 'New Opening Explorer',
    component: () => import('../views/deprecated/ExplorerFutureView.vue')
  },
  {
    path: '/explorerwinloss',
    name: 'New Winloss Explorer',
    component: () => import('../views/opening/ExplorerWinLossView.vue')
  },
  {
    path: '/lichesschallenge',
    name: 'Lichess Challenge',
    component: () => import('../views/lichess_play/LichessChallengeView.vue')
  },
  {
    path: '/lichessplay',
    name: 'Lichess Play',
    component: () => import('../views/lichess_play/LichessPlayView.vue')
  },
  {
    path: '/lichessopen',
    name: 'Lichess Open',
    component: () => import('../views/lichess_play/LichessOpenView.vue')
  },
  {
    path: '/lichessarena',
    name: 'Lichess Arena',
    component: () => import('../views/lichess_play/LichessArenaView.vue')
  },
  {
    path: '/lichessfriends',
    name: 'Lichess Friends',
    component: () => import('../views/lichess_play/LichessFriendView.vue')
  },
  {
    path: '/lichessconnect',
    name: 'Lichess Connect',
    component: () => import('../views/lichess_play/LichessConnectView.vue')
  },
  {
    path: '/lichessdisconnect',
    name: 'Lichess Disconnect',
    component: () => import('../views/lichess_play/LichessDisconnectView.vue')
  },
  {
    path: '/eyegazemenu',
    name: 'Eye Gaze Menu',
    component: () => import('../views/initial_screens/EyeGazeMenuView.vue')
  },
  {
    path: '/downloadgames',
    name: 'Download Games',
    component: () => import('../views/opening/DownloadGamesView.vue')
  },
  {
    path: '/easteregg',
    name: 'Easter Egg',
    component: () => import('../views/support/EasterEggView.vue')
  },
  {
    path: '/fromios',
    name: 'Setup from IOS',
    component: () => import('../views/you/FromIOSView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
